<template>
  <div
    class="w-100 h-100 position-relative"
    style="min-width: 1000px;"
  >
    <svg
      :ref="'canvas'"
      style="position: absolute; top: 0; left: 0;width: 100%; height: 100%"
    >
      <line
        v-for="(e, index) in edges"
        :key="index"
        v-bind="e"
        stroke="rgba(100,100,100,0.7)"
        stroke-width="3"
      />
    </svg>

    <div class="row h-100 mx-3 text-left">
      <div class="col-4 px-4">
        <h4 class="text-center">
          *
        </h4>
        <hr class="mt-0">
        <div
          v-for="badge in sorted(1)"
          :key="badge.id"
        >
          <BadgeBox
            :ref="`badge${badge.id}`"
            class="my-1"
            v-bind="badge"
            :editing="editedId === badge.id"
            :editable="editable"
            @edit="$emit('edit', badge)"
            @remove="remove(badge.id)"
          />
        </div>
      </div>
      <div class="col-4 px-4">
        <h4 class="text-center">
          **
        </h4>
        <hr class="mt-0">
        <div
          v-for="badge in sorted(2)"
          :key="badge.id"
        >
          <BadgeBox
            :ref="`badge${badge.id}`"
            class="my-1"
            v-bind="badge"
            :editing="editedId === badge.id"
            :editable="editable"
            @edit="$emit('edit', badge)"
            @remove="remove(badge.id)"
          />
        </div>
      </div>
      <div class="col-4 px-4">
        <h4 class="text-center">
          ***
        </h4>
        <hr class="mt-0">
        <div
          v-for="badge in sorted(3)"
          :key="badge.id"
        >
          <BadgeBox
            :ref="`badge${badge.id}`"
            class="my-1"
            v-bind="badge"
            :editing="editedId === badge.id"
            :editable="editable"
            @edit="$emit('edit', badge)"
            @remove="remove(badge.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BadgeBox from './BadgeBox';

export default {
  props: {
    list: Array,
    editedId: String,
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    positions: null,
    box: {},
  }),
  components: {
    BadgeBox,
  },
  computed: {
    edges() {
      if (!this.positions) return [];
      const edges = this.list.flatMap((b) => {
        if (!b.basedOn || b.stars === 1) return [];
        if (!Array.isArray(b.basedOn)) {
          return [{
            from: b.basedOn,
            to: b.id,
          }];
        }

        return b.basedOn.map((x) => ({
          from: x,
          to: b.id,
        }));
      });

      if (!this.$refs.canvas) return [];
      const { canvas } = this.$refs;
      const svgBox = canvas.getBoundingClientRect();

      return edges.map(({ from, to }) => ({
        from: this.positions[from] || {},
        to: this.positions[to] || {},
      }))
        .filter(({ from, to }) => from && to)
        .map(({ from, to }) => ({
          x1: (from.left - svgBox.left) + (from.width),
          y1: (from.top - svgBox.top) + (from.height / 2),
          x2: (to.left - svgBox.left),
          y2: (to.top - svgBox.top) + (to.height / 2),
        }));
    },
  },
  watch: {
    list() {
      this.$nextTick(() => {
        this.redraw();
      });
    },
  },
  methods: {
    sorted(n) {
      if (n === 1) {
        return this.list.filter((b) => b.stars === n);
      }
      const lower = this.sorted(n - 1);
      const all = this.list.filter((b) => b.stars === n);
      return all.sort((a, b) => {
        if (!a.basedOn) return 1;
        if (!b.basedOn) return -1;
        const bIndex = lower.findIndex((l) => l.id === b.basedOn);
        const aIndex = lower.findIndex((l) => l.id === a.basedOn);
        return aIndex - bIndex;
      });
    },
    redraw() {
      this.positions = this.list.map((b) => {
        const refs = this.$refs[`badge${b.id}`];
        if (!refs || refs.length === 0) return null;
        return { id: b.id, box: refs[0].$el.getBoundingClientRect() };
      })
        .filter((e) => e)
        .reduce((acc, curr) => {
          acc[curr.id] = curr.box;
          return acc;
        }, {});
    },
    remove(id) {
      this.$store.commit('removeBadge', id);
    },
  },
  mounted() {
    this.$nextTick(() => {
      setInterval(() => {
        this.redraw();
      }, 1000);
    });
  },
};
</script>

<style>

</style>
